// extracted by mini-css-extract-plugin
export var arrow = "hC_dp";
export var container = "hC_f";
export var contentWrapper = "hC_qr";
export var description = "hC_c";
export var descriptionLink = "hC_qs";
export var image = "hC_fM";
export var innerContainer = "hC_fq";
export var link = "hC_b5";
export var text = "hC_c3";
export var title = "hC_b";